import React, { useEffect, useState } from "react";
import {
    Button, Form, Badge, Card, Spinner, Modal,
    Container, Table, InputGroup
} from 'react-bootstrap';
import Menu from '../../comum/Menu/menu.jsx';
import { useNavigate } from "react-router-dom";
import Footer from '../../comum/Footer/index.jsx';
import { api } from '../../services/api.js';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { FaFilePdf, FaCheck, FaTimes, FaUsers, FaSearch } from 'react-icons/fa';

const MySwal = withReactContent(Swal);

function AprovacaoPendencias() {
    const [loading, setLoading] = useState(false);
    const [pendencias, setPendencias] = useState([]);
    const [historico12, setHistorico12] = useState([]);
    const [notasDoLancamento, setNotasDoLancamento] = useState([]);
    const [anexosContrato, setAnexosContrato] = useState([]);
    const [aprovacoesWorkflow, setAprovacoesWorkflow] = useState([]);
    const [fchHistoricaAberta, setFchHistoricaAberta] = useState(false);

    // Modal de Detalhes / Assinatura
    const [showModalAssinar, setShowModalAssinar] = useState(false);
    const [lancamentoSelecionado, setLancamentoSelecionado] = useState(null);
    const [obsAprovacao, setObsAprovacao] = useState("");
    const [chapaOutroAutorizador, setChapaOutroAutorizador] = useState("");

    // Modal do Fluxo de Assinaturas (Workflow)
    const [showModalWorkflow, setShowModalWorkflow] = useState(false);

    // Modal de Leitura de PDF
    const [showModalPDF, setShowModalPDF] = useState(false);
    const [urlPdfView, setUrlPdfView] = useState("");
    const [tituloPdfView, setTituloPdfView] = useState("");

    const chapa = localStorage.getItem("chapa");
    const usuarioLogado = localStorage.getItem("usuario_matricula") || localStorage.getItem("chapa") || "";
    const navigate = useNavigate();

    const formatarMoedaBR = (valor) => {
        const num = Number(valor) || 0;
        return num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    };

    useEffect(() => {
        if (!chapa) {
            navigate("/arbor/login");
            return;
        }
        carregarPendencias();
    }, []);

    const carregarPendencias = async () => {
        setLoading(true);
        try {
            const res = await api.get(`/financeiro/pendencias/${usuarioLogado}`);
            setPendencias(Array.isArray(res.data) ? res.data : []);
        } catch (err) {
            toast.error("Erro ao carregar pendências de assinatura.");
        } finally {
            setLoading(false);
        }
    };

    const carregarWorkflowAprovacoes = async (finlId) => {
        try {
            const res = await api.get(`/financeiro/lancamento/${finlId}/aprovacoes`);
            const lista = Array.isArray(res.data) ? res.data : [];

            const listaComNomes = await Promise.all(
                lista.map(async (item) => {
                    let nome = "";
                    const mat = item.FINA_MATRICULA || item.fina_matricula || item.FINP_MATRICULA || item.finp_matricula || "";
                    if (mat) {
                        try {
                            const resUsr = await api.get(`/usuario/dados/${mat}`);
                            const dUsr = Array.isArray(resUsr.data) ? resUsr.data[0] : resUsr.data;
                            if (dUsr) nome = dUsr.nome;
                        } catch (e) { }
                    }
                    return { ...item, NOME_COLABORADOR: nome, MATRICULA_CORRETA: mat };
                })
            );

            setAprovacoesWorkflow(listaComNomes);
        } catch (err) {
            toast.error("Erro ao carregar o workflow de aprovações.");
        }
    };

    const handleAbrirParaAssinar = async (item) => {
        setLancamentoSelecionado(item);
        setObsAprovacao("");
        setChapaOutroAutorizador("");
        setFchHistoricaAberta(false);

        const finlId = item.FINL_ID || item.finl_id;
        const fincId = item.FINC_ID || item.finc_id;

        setLoading(true);
        try {
            const [resNotas, resHist, resAnx] = await Promise.all([
                api.get(`/financeiro/lancamento/${finlId}/notas`),
                api.get(`/financeiro/historico/${fincId}`),
                api.get(`/financeiro/contrato/${fincId}/anexos`)
            ]);
            setNotasDoLancamento(Array.isArray(resNotas.data) ? resNotas.data : []);
            setHistorico12(Array.isArray(resHist.data) ? resHist.data : []);
            setAnexosContrato(Array.isArray(resAnx.data) ? resAnx.data : []);
            
            await carregarWorkflowAprovacoes(finlId);

            setShowModalAssinar(true);
        } catch (err) {
            toast.error("Erro ao carregar detalhes do lançamento.");
        } finally {
            setLoading(false);
        }
    };

    const handleAprovarRejeitar = async (statusAprov) => {
        if (statusAprov === 'SOLICITAR_OUTRA' && !chapaOutroAutorizador.trim()) {
            toast.warning("Informe a chapa do autorizador adicional para encaminhar a assinatura.");
            return;
        }

        const isAprov = statusAprov === 'APROVADO';
        const isEncaminhar = statusAprov === 'SOLICITAR_OUTRA';

        const confirm = await MySwal.fire({
            title: isAprov ? 'Autorizar Lançamento?' : isEncaminhar ? 'Encaminhar Assinatura?' : 'Negar Lançamento?',
            text: `Confirmar ${isAprov ? 'aprovação' : isEncaminhar ? 'encaminhamento' : 'negação'} da competência ${lancamentoSelecionado?.FINL_COMPETENCIA || lancamentoSelecionado?.finl_competencia}?`,
            icon: isAprov ? 'question' : 'warning',
            showCancelButton: true,
            confirmButtonText: isAprov ? 'Sim, Autorizar' : isEncaminhar ? 'Sim, Encaminhar' : 'Sim, Negar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: isAprov ? '#8b0000' : '#dc3545'
        });

        if (confirm.isConfirmed) {
            setLoading(true);
            try {
                await api.post('/financeiro/lancamento/aprovar', {
                    finl_id: lancamentoSelecionado.FINL_ID || lancamentoSelecionado.finl_id,
                    fina_id: lancamentoSelecionado.FINA_ID || lancamentoSelecionado.fina_id,
                    usuario_logado: usuarioLogado,
                    status_aprovação: statusAprov === 'REJEITADO' ? 'NEGADO' : statusAprov,
                    observacao: obsAprovacao,
                    redirecionar_matricula: chapaOutroAutorizador
                });

                if (statusAprov === 'REJEITADO' || statusAprov === 'NEGADO') {
                    toast.warn("Processo NEGADO e devolvido ao criador para correções.");
                } else {
                    toast.success(`Assinatura registrada com sucesso!`);
                }

                setShowModalAssinar(false);
                carregarPendencias();
            } catch (err) {
                toast.error("Erro ao registrar assinatura.");
            } finally {
                setLoading(false);
            }
        }
    };

    const handleAbrirPDFNota = async (finnId, numNota) => {
        if (!finnId) {
            toast.warning("Identificador da nota não encontrado.");
            return;
        }
        setLoading(true);
        try {
            const response = await api.get(`/financeiro/nota/download/${finnId}`, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(blob);
            setTituloPdfView(`Nota Fiscal nº ${numNota || 'S/N'}`);
            setUrlPdfView(pdfUrl);
            setShowModalPDF(true);
        } catch (err) {
            toast.error("Erro ao carregar o PDF da Nota Fiscal.");
        } finally {
            setLoading(false);
        }
    };

    const handleAbrirPDFContrato = async (fincId, descContrato) => {
        if (!fincId) {
            toast.warning("Identificador do contrato não encontrado.");
            return;
        }
        setLoading(true);
        try {
            const response = await api.get(`/financeiro/contrato/download/${fincId}`, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(blob);
            setTituloPdfView(`Contrato: ${descContrato || ''}`);
            setUrlPdfView(pdfUrl);
            setShowModalPDF(true);
        } catch (err) {
            toast.error("Erro ao carregar o PDF do Contrato.");
        } finally {
            setLoading(false);
        }
    };

    const handleAbrirPDFAnexo = async (finaId, tituloAnx) => {
        if (!finaId) {
            toast.warning("Identificador do anexo não encontrado.");
            return;
        }
        setLoading(true);
        try {
            const response = await api.get(`/financeiro/contrato/anexo/download/${finaId}`, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(blob);
            setTituloPdfView(tituloAnx);
            setUrlPdfView(pdfUrl);
            setShowModalPDF(true);
        } catch (err) {
            toast.error("Erro ao carregar o PDF do Anexo.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
            <Menu modulo="ARBOR" />

            <Container fluid className="px-2 px-md-4 pt-5 mt-4 mb-5" style={{ flex: 1, maxWidth: '900px' }}>
                <div className="d-flex justify-content-between align-items-center mb-3 bg-white p-3 rounded-3 shadow-sm border">
                    <div>
                        <h5 className="fw-bold text-dark mb-0">✍️ Assinaturas Pendentes</h5>
                        <small className="text-muted">Usuário: {usuarioLogado}</small>
                    </div>
                    <Badge bg={pendencias.length > 0 ? "danger" : "success"} className="p-2 fs-6 rounded-2">
                        {pendencias.length} {pendencias.length === 1 ? 'item' : 'itens'}
                    </Badge>
                </div>

                {pendencias.length === 0 ? (
                    <Card className="text-center p-5 border-0 shadow-sm rounded-3 bg-white">
                        <Card.Body>
                            <span className="fs-1">🎉</span>
                            <h6 className="fw-bold mt-2 text-dark">Nenhuma pendência encontrada!</h6>
                            <p className="text-muted small mb-0">Você está em dia com todas as aprovações de contratos e notas.</p>
                        </Card.Body>
                    </Card>
                ) : (
                    pendencias.map((item, idx) => (
                        <Card key={idx} className="mb-3 border-0 shadow-sm rounded-3 bg-white overflow-hidden">
                            <Card.Body className="p-3">
                                <div className="d-flex justify-content-between align-items-start mb-2">
                                    <div>
                                        <div className="d-flex align-items-center gap-1 mb-1">
                                            <Badge style={{ backgroundColor: '#8b0000' }}>{item.FINL_COMPETENCIA || item.finl_competencia}</Badge>
                                            <Badge bg="dark">{item.FINC_DEPARTAMENTO || item.finc_departamento || 'TI'}</Badge>
                                        </div>
                                        <h6 className="fw-bold text-dark mb-0">{item.FINC_DESCRICAO || item.finc_descricao}</h6>
                                        <small className="text-muted d-block">{item.FINC_FORNECEDOR || item.finc_fornecedor}</small>
                                    </div>
                                    <Badge bg="warning-subtle" text="warning-emphasis" className="border border-warning-subtle fw-bold">{item.FINA_CARGO || item.fina_cargo}</Badge>
                                </div>

                                <div className="d-flex justify-content-between align-items-center bg-light p-2 rounded-2 my-2 border">
                                    <span className="small text-muted">Total Competência:</span>
                                    <span className="fw-bold text-danger fs-5">
                                        {formatarMoedaBR(item.FINL_VALOR_TOTAL || item.finl_valor_total)}
                                    </span>
                                </div>

                                <Button
                                    style={{ backgroundColor: '#8b0000', borderColor: '#8b0000' }}
                                    className="w-100 fw-bold py-2 text-white shadow-sm d-flex justify-content-center align-items-center gap-2 mt-2"
                                    onClick={() => handleAbrirParaAssinar(item)}
                                >
                                    <FaSearch size={14} /> Analisar e Assinar
                                </Button>
                            </Card.Body>
                        </Card>
                    ))
                )}
            </Container>

            {/* MODAL RESPONSIVO DE APROVAÇÃO */}
            <Modal show={showModalAssinar} onHide={() => setShowModalAssinar(false)} fullscreen="md-down" size="lg" centered scrollable>
                <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 50%, #c0392b 100%)', color: '#ffffff' }} className="py-2 px-3 border-0">
                    <Modal.Title className="fs-6 fw-bold mb-0 text-white">
                        [{lancamentoSelecionado?.FINC_DEPARTAMENTO || lancamentoSelecionado?.finc_departamento || 'TI'}] {lancamentoSelecionado?.FINC_DESCRICAO || lancamentoSelecionado?.finc_descricao} ({lancamentoSelecionado?.FINL_COMPETENCIA || lancamentoSelecionado?.finl_competencia})
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3 bg-light">

                    <Button
                        variant="outline-danger"
                        className="w-100 fw-bold py-2 mb-3 shadow-sm d-flex justify-content-between align-items-center bg-white rounded-3"
                        onClick={() => setShowModalWorkflow(true)}
                    >
                        <div className="d-flex align-items-center gap-2">
                            <FaUsers />
                            <span>Fluxo de Assinaturas e Status das Alçadas</span>
                        </div>
                        <Badge style={{ backgroundColor: '#8b0000' }}>
                            {aprovacoesWorkflow.length} Alçada(s)
                        </Badge>
                    </Button>

                    <Card className="border-0 shadow-sm rounded-3 mb-3 bg-white">
                        <Card.Header className="bg-white fw-bold small py-2 px-3 d-flex justify-content-between align-items-center border-bottom">
                            <span>📄 Documentos e Adendos do Contrato ({anexosContrato.length > 0 ? anexosContrato.length : 1})</span>
                        </Card.Header>
                        <Card.Body className="p-2">
                            {anexosContrato.length > 0 ? (
                                anexosContrato.map((anx, aIdx) => {
                                    const anxId = anx.FINA_ID || anx.fina_id;
                                    const anxTipo = anx.FINA_TIPO || anx.fina_tipo || "DOCUMENTO";
                                    const anxNome = anx.FINA_NOME_ARQ || anx.fina_nome_arq || "";
                                    const anxDesc = anx.FINA_DESCRICAO || anx.fina_descricao || anxNome;

                                    return (
                                        <div key={aIdx} className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-2 last-border-0 flex-wrap gap-2 px-2">
                                            <div style={{ maxWidth: '70%' }}>
                                                <Badge bg={anxTipo === 'CONTRATO' ? 'danger' : 'warning'} className="me-2">
                                                    {anxTipo}
                                                </Badge>
                                                <span className="fw-bold small text-dark text-break">{anxDesc}</span>
                                            </div>
                                            <Button
                                                size="sm"
                                                variant="outline-danger"
                                                className="py-0 px-2 fw-bold ms-auto"
                                                style={{ fontSize: '0.72rem' }}
                                                onClick={() => handleAbrirPDFAnexo(anxId, `${anxTipo}: ${anxDesc}`)}
                                            >
                                                👁️ Visualizar PDF
                                            </Button>
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 px-2">
                                    <div>
                                        <Badge style={{ backgroundColor: '#8b0000' }} className="me-2">CONTRATO</Badge>
                                        <span className="fw-bold small text-dark">Contrato Principal PDF</span>
                                    </div>
                                    <Button
                                        size="sm"
                                        variant="outline-danger"
                                        className="py-0 px-2 fw-bold ms-auto"
                                        style={{ fontSize: '0.72rem' }}
                                        onClick={() => handleAbrirPDFContrato(
                                            lancamentoSelecionado?.FINC_ID || lancamentoSelecionado?.finc_id,
                                            lancamentoSelecionado?.FINC_DESCRICAO || lancamentoSelecionado?.finc_descricao
                                        )}
                                    >
                                        👁️ Visualizar PDF
                                    </Button>
                                </div>
                            )}
                        </Card.Body>
                    </Card>

                    {(lancamentoSelecionado?.FINL_OBSERVACAO || lancamentoSelecionado?.finl_observacao) && (
                        <div className="alert alert-warning border-start border-4 border-warning shadow-sm mb-3 rounded-2">
                            <strong className="d-block text-dark">⚠️ Motivo da Alteração de Valor / Reajuste:</strong>
                            <span className="small text-break">{lancamentoSelecionado?.FINL_OBSERVACAO || lancamentoSelecionado?.finl_observacao}</span>
                        </div>
                    )}

                    <Card className="border-0 shadow-sm rounded-3 mb-3 bg-white">
                        <Card.Header className="bg-white fw-bold small py-2 px-3 border-bottom">
                            🧾 Notas Fiscais Deste Lançamento ({notasDoLancamento.length})
                        </Card.Header>
                        <Card.Body className="p-2">
                            {notasDoLancamento.map((nf, i) => {
                                const idNota = nf.FINN_ID || nf.finn_id;
                                const numNota = nf.FINN_NUMERO || nf.finn_numero;
                                return (
                                    <div key={i} className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-2 last-border-0 flex-wrap gap-2 px-2">
                                        <div>
                                            <Badge bg="secondary" className="me-1">{nf.FINN_TIPO_NOTA || nf.finn_tipo_nota}</Badge>
                                            <span className="fw-bold small text-dark">NF nº {numNota}</span>
                                            <div className="text-muted extra-small">Loja {nf.FINN_COD_EMP || nf.finn_cod_emp} • Venc: {nf.FINN_DATA_VENCIMENTO || nf.finn_data_vencimento}</div>
                                        </div>
                                        <div className="text-end ms-auto">
                                            <div className="fw-bold small text-danger">{formatarMoedaBR(nf.FINN_VALOR || nf.finn_valor)}</div>
                                            <Button
                                                size="sm"
                                                variant="outline-danger"
                                                className="py-0 px-2 mt-1 fw-bold"
                                                style={{ fontSize: '0.72rem' }}
                                                onClick={() => handleAbrirPDFNota(idNota, numNota)}
                                            >
                                                👁️ Ver PDF
                                            </Button>
                                        </div>
                                    </div>
                                );
                            })}
                        </Card.Body>
                    </Card>

                    <Card className="border-0 shadow-sm rounded-3 mb-3 bg-white">
                        <Card.Header
                            className="bg-white fw-bold small py-2 px-3 d-flex justify-content-between align-items-center"
                            onClick={() => setFchHistoricaAberta(!fchHistoricaAberta)}
                            style={{ cursor: 'pointer' }}
                        >
                            <span>📊 Histórico dos Últimos 12 Meses (Ficha Rosa)</span>
                            <span>{fchHistoricaAberta ? '▲' : '▼'}</span>
                        </Card.Header>
                        {fchHistoricaAberta && (
                            <Card.Body className="p-2 p-md-0 border-top">
                                {historico12.length === 0 ? (
                                    <div className="text-center py-3 text-muted small">
                                        Nenhum histórico encontrado.
                                    </div>
                                ) : (
                                    <>
                                        <div className="d-block d-md-none">
                                            {historico12.map((h, index) => {
                                                const obs = h.FINL_OBSERVACAO || h.finl_observacao || "";
                                                const status = h.FINL_STATUS || h.finl_status;
                                                return (
                                                    <div key={index} className="p-2 border-bottom bg-white rounded mb-2 shadow-sm">
                                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                                            <strong className="text-danger">{h.FINL_COMPETENCIA || h.finl_competencia}</strong>
                                                            <Badge bg={status === 'APROVADO' ? 'success' : status === 'NEGADO' || status === 'REJEITADO' ? 'danger' : 'warning'}>
                                                                {status}
                                                            </Badge>
                                                        </div>
                                                        <div className="d-flex justify-content-between align-items-center small mb-1">
                                                            <span className="text-muted">{h.QTD_NOTAS || h.qtd_notas || 1} NF(s)</span>
                                                            <strong className="text-danger">{formatarMoedaBR(h.FINL_VALOR_TOTAL || h.finl_valor_total)}</strong>
                                                        </div>
                                                        {obs && (
                                                            <div className="bg-light p-1 rounded extra-small text-muted mt-1 text-break">
                                                                💬 {obs}
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>

                                        <div className="d-none d-md-block">
                                            <Table striped bordered hover size="sm" className="mb-0 extra-small align-middle" style={{ tableLayout: 'fixed', width: '100%' }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '15%' }}>Mês</th>
                                                        <th style={{ width: '22%' }}>Total</th>
                                                        <th style={{ width: '10%' }}>NFs</th>
                                                        <th style={{ width: '18%' }}>Status</th>
                                                        <th style={{ width: '35%' }}>Observação / Motivo</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {historico12.map((h, index) => {
                                                        const obs = h.FINL_OBSERVACAO || h.finl_observacao || "-";
                                                        const status = h.FINL_STATUS || h.finl_status;
                                                        return (
                                                            <tr key={index}>
                                                                <td className="fw-bold">{h.FINL_COMPETENCIA || h.finl_competencia}</td>
                                                                <td>{formatarMoedaBR(h.FINL_VALOR_TOTAL || h.finl_valor_total)}</td>
                                                                <td>{h.QTD_NOTAS || h.qtd_notas || 1}</td>
                                                                <td>
                                                                    <Badge bg={status === 'APROVADO' ? 'success' : status === 'NEGADO' || status === 'REJEITADO' ? 'danger' : 'warning'}>
                                                                        {status}
                                                                    </Badge>
                                                                </td>
                                                                <td className="text-break" style={{ whiteSpace: 'normal' }}>
                                                                    <small className="text-muted">{obs}</small>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </>
                                )}
                            </Card.Body>
                        )}
                    </Card>

                    <Card className="p-3 border-0 bg-white shadow-sm rounded-3 mb-2">
                        <Form.Group className="mb-2">
                            <Form.Label className="small fw-bold text-secondary">Observações / Ressalvas / Motivo de Negação</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={2}
                                placeholder="Adicione um comentário antes de assinar ou a justificativa ao negar..."
                                value={obsAprovacao}
                                onChange={(e) => setObsAprovacao(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group className="mt-3">
                            <Form.Label className="small fw-bold text-danger">
                                🔄 Solicitar Segunda Assinatura / Transferir para Outro Autorizador (Opcional)
                            </Form.Label>
                            <InputGroup size="sm">
                                <Form.Control
                                    placeholder="Digite a Chapa/Matrícula do Diretor/Autorizador adicional..."
                                    value={chapaOutroAutorizador}
                                    onChange={(e) => setChapaOutroAutorizador(e.target.value)}
                                />
                                <Button
                                    variant="outline-danger"
                                    className="fw-bold"
                                    onClick={() => handleAprovarRejeitar('SOLICITAR_OUTRA')}
                                >
                                    👉 Encaminhar Assinatura
                                </Button>
                            </InputGroup>
                        </Form.Group>
                    </Card>
                </Modal.Body>

                <Modal.Footer className="p-2 bg-white border-top-0 d-flex justify-content-between gap-2">
                    <Button
                        variant="outline-danger"
                        className="flex-grow-1 py-2 fw-bold"
                        onClick={() => handleAprovarRejeitar('REJEITADO')}
                    >
                        ❌ Negar / Devolver
                    </Button>
                    <Button
                        style={{ backgroundColor: '#8b0000', borderColor: '#8b0000' }}
                        className="flex-grow-1 py-2 fw-bold text-white shadow-sm"
                        onClick={() => handleAprovarRejeitar('APROVADO')}
                    >
                        ✍️ Autorizar
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* MODAL WORKFLOW */}
            <Modal 
                show={showModalWorkflow} 
                onHide={() => setShowModalWorkflow(false)} 
                size="lg" 
                centered
            >
                <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 50%, #c0392b 100%)', color: '#ffffff' }} className="py-2 px-3 border-0">
                    <Modal.Title className="fs-6 fw-bold text-white">
                        👥 Fluxo de Assinaturas e Status das Alçadas
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    <Table responsive hover size="sm" className="mb-0 align-middle small text-break" style={{ tableLayout: 'fixed', width: '100%' }}>
                        <thead className="table-light">
                            <tr>
                                <th style={{ width: '12%' }} className="ps-3">Ordem</th>
                                <th style={{ width: '23%' }}>Cargo</th>
                                <th style={{ width: '25%' }}>Aprovador</th>
                                <th style={{ width: '20%' }}>Status</th>
                                <th style={{ width: '20%' }} className="pe-3">Data/Hora</th>
                            </tr>
                        </thead>
                        <tbody>
                            {aprovacoesWorkflow.length === 0 ? (
                                <tr>
                                    <td colSpan="5" className="text-center py-4 text-muted">
                                        Nenhum workflow registrado para esta competência.
                                    </td>
                                </tr>
                            ) : (
                                aprovacoesWorkflow.map((wf, widx) => {
                                    const status = (wf.FINP_STATUS || wf.finp_status || 'PENDENTE').toUpperCase();
                                    const isAprov = status === 'APROVADO';
                                    const isRej = status === 'REJEITADO' || status === 'NEGADO';
                                    const matricula = wf.MATRICULA_CORRETA || wf.FINA_MATRICULA || wf.fina_matricula || '';
                                    const dataHora = wf.FINP_DATAHORA || wf.finp_datahora || '-';

                                    return (
                                        <tr key={widx}>
                                            <td className="fw-bold ps-3">#{wf.FINA_ORDEM || wf.fina_ordem || widx + 1}</td>
                                            <td><Badge bg="secondary-subtle" text="secondary" className="border border-secondary-subtle">{wf.FINA_CARGO || wf.fina_cargo}</Badge></td>
                                            <td>
                                                <strong>
                                                    {wf.NOME_COLABORADOR
                                                        ? `${wf.NOME_COLABORADOR} [${matricula}]`
                                                        : (matricula ? `Chapa: ${matricula}` : 'Aprovador não definido')}
                                                </strong>
                                            </td>
                                            <td>
                                                <Badge bg={isAprov ? 'success' : isRej ? 'danger' : 'warning'}>
                                                    {isAprov ? '✓ Aprovado' : isRej ? '❌ Negado' : '⏳ Aguardando'}
                                                </Badge>
                                            </td>
                                            <td className="pe-3 text-muted extra-small">{dataHora}</td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer className="bg-white border-top-0 py-2 px-3">
                    <Button variant="secondary" size="sm" className="fw-semibold" onClick={() => setShowModalWorkflow(false)}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* MODAL VISUALIZADOR DE PDF */}
            <Modal show={showModalPDF} onHide={() => setShowModalPDF(false)} fullscreen size="lg" centered style={{ zIndex: 1060 }}>
                <Modal.Header closeButton className="bg-dark text-white py-2 px-3">
                    <Modal.Title className="fs-6 fw-bold d-flex align-items-center gap-2">
                        <FaFilePdf /> {tituloPdfView}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0 bg-secondary">
                    <iframe src={urlPdfView} title="PDF Viewer" width="100%" height="100%" style={{ border: 'none', minHeight: '80vh' }} />
                </Modal.Body>
            </Modal>

            {/* SPINNER GLOBAL */}
            <Modal show={loading} backdrop="static" keyboard={false} centered size="sm" contentClassName="bg-transparent border-0">
                <Modal.Body className="text-center">
                    <Spinner animation="border" variant="light" style={{ width: '3rem', height: '3rem' }} />
                    <div className="text-light mt-2 fw-bold">Carregando...</div>
                </Modal.Body>
            </Modal>

            <Footer />
        </div>
    );
}

export default AprovacaoPendencias;